export function isNotPrimitive<T extends object>(value: any): value is T {
  return value && typeof value === 'object'
}

export class DataSerializer {
  static toFormData(model: Record<any, any>, root: boolean = true) {
    if (!model) {
      throw new Error('model is required')
    }

    const result = new FormData()

    Object.keys(model).forEach((key) => {
      const value = model[key]

      if (value === undefined || value === null) {
        return
      }

      const isComplex = isNotPrimitive(value)
      const isArray = Array.isArray(value)
      const isBlob = value instanceof Blob
      const isPojo = isComplex && !isArray && !isBlob

      if (isArray && value[0] instanceof Blob) {
        const valuesArray = (value as any[]).filter(
          value => value !== undefined,
        )
        valuesArray.forEach(value =>
          result.append(root ? key : `[${key}]`, value),
        )
      } else if (isPojo || isArray) {
        const innerObjectData = this.toFormData(value, false)

        innerObjectData.forEach((dataValue, dataKey) => {
          const field = []
          field.push(root ? key : `[${key}]`)
          field.push(dataKey)
          result.append(field.join(''), dataValue)
        })
      } else {
        result.append(root ? key : `[${key}]`, value)
      }
    })

    return result
  }
}
